module.exports = __webpack_public_path__ + "static/media/boston.73d17184.jpg";